import React, { useState } from "react"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { FILTER_NOTIFICATIONS } from "constants/events"
import { FOLLOW_REQUEST, NOTIFICATIONS_MAP } from "constants/notifications"
import FollowRequestButtons from "components/molecules/Notification/FollowRequestButtons"
import UserCard from "components/molecules/UserCard"
import FollowButton from "components/molecules/FollowButton"

type FollowRequestNotificationProps = {
  notification: FollowRequest;
}

export default function FollowRequestNotification(props: FollowRequestNotificationProps) {
  const { notification } = props

  const [followAccepted, setFollowAccepted] = useState<boolean>(false)
  const [followStatus, setFollowStatus] = useState<FollowStatus | null>(null)

  function handleNotificationClicked() {
    const eventDetail = {
      id: notification.followerId,
      handle: notification.followerHandle
    }
    document.dispatchEvent(new CustomEvent(NOTIFICATIONS_MAP[FOLLOW_REQUEST].onClickEvent, { detail: eventDetail }))
  }

  function handleFollowAccepted(notificationId: number, followerId: number, status: FollowStatus) {
    setFollowAccepted(true)
    setFollowStatus(status)
  }

  function handleFollowRejected(notificationId: number, followerId: number) {
    document.dispatchEvent(new CustomEvent(FILTER_NOTIFICATIONS, { detail: { notificationId, followerId } }))
  }

  return (
    <NotificationContainer>
      <UserCard
        id={notification.followerId}
        handle={notification.followerHandle}
        name={notification.followerName}
        avatar={notification.followerAvatar}
        avatarWidth={"46px"}
        skipDefaultNavigation={true}
        onClick={handleNotificationClicked}
      />

      {!followAccepted && <FollowRequestButtons
          followerId={notification.followerId}
          onAccept={handleFollowAccepted}
          onReject={handleFollowRejected}
      />}
      {(followAccepted && followStatus) && <FollowButton
          userId={notification.followerId}
          handle={notification.followerHandle}
          status={followStatus}
      />}
    </NotificationContainer>
  )
}

const NotificationContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "4px",
  margin: "8px 0",

  "& .avatar": {
    width: "46px",
    height: "46px",
    marginRight: "6px"
  }
}))
